import React from 'react';
import { Box, List, ListItem, Switch, Typography } from '@mui/material';
import type { IClinic } from '@app/interfaces/clinic.interface';
import { toggleNewFbSite } from '@app/api/clinic';

type Props = {
  clinic: IClinic;
  setClinic: (clinic: IClinic) => void;
};

function NewFbSiteToggler({ clinic, setClinic }: Props) {
  const handleToggle = async () => {
    const updatedClinic = await toggleNewFbSite(clinic.id);

    if (updatedClinic) {
      setClinic(updatedClinic);
    }
  };

  return (
    <Box>
      <Typography variant='h6'>Сайты отзывов:</Typography>

      <List dense={true}>
        <ListItem disablePadding>
          <Switch
            edge='start'
            onChange={handleToggle}
            checked={clinic.isNewFbSite}
            sx={{ marginRight: 2 }}
            color='success'
          />
        </ListItem>
      </List>
    </Box>
  );
}

export default NewFbSiteToggler;
